import React from "react";
import "../pages/player-slider/Player-slider.css";
import { GiWhistle } from "react-icons/gi";
import { BiSolidMegaphone } from "react-icons/bi";

const AudioButtons = ({ eventType, audioType, changeAudio, isLoading }) => {
  return (
    <div className="button-container">
      <button
        className={audioType === "referee" ? "btn active" : "btn"}
        {...(eventType === "touch"
          ? { onTouchStart: () => changeAudio("referee") }
          : { onClick: () => changeAudio("referee") })}
        disabled={isLoading !== 0}
      >
        {isLoading === 1 ? (
          <span className="spinner"></span>
        ) : (
          <div className="btnDiv">
            {" "}
            <GiWhistle
              color={audioType === "referee" ? "white" : "black"}
              size={25}
            />{" "}
            <span style={{ fontSize: 15 }}>Referee</span>
          </div>
        )}
      </button>
      <button
        className={audioType === "commentator" ? "btn active" : "btn"}
        onTouchStart={() => changeAudio("commentator")}
        {...(eventType === "touch"
          ? { onTouchStart: () => changeAudio("commentator") }
          : { onClick: () => changeAudio("commentator") })}
        disabled={isLoading !== 0}
      >
        {isLoading === 2 ? (
          <span className="spinner"></span>
        ) : (
          <div className="btnDiv">
            {" "}
            <BiSolidMegaphone
              color={audioType === "commentator" ? "white" : "black"}
              size={25}
            />{" "}
            <span style={{ fontSize: 15 }}>Commentator</span>
          </div>
        )}
      </button>
    </div>
  );
};

export default AudioButtons;
